<div class="tabela-scroll-mobile">
  <table class="table table-hover align-middle table-scroll">
    <thead class="head-table">
      <tr class="title">
        <th
          *ngFor="let column of columns"
          class="title-table"
          [style.cursor]="
            column.sortable && column.field !== 'workId' ? 'pointer' : 'default'
          "
          (click)="
            column.sortable && column.field !== 'workId'
              ? ordenarPorCampo(column.field)
              : null
          "
          [title]="column.title"
        >
          {{ column.label }}
          <img
            *ngIf="column.sortable && column.field !== 'workId'"
            src="{{
              BASE_IMG_URL
            }}assets/agenda-tarefas/order.svg"
            alt="ordenar"
            width="16"
            height="16"
          />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let row of data; trackBy: trackByFn"
        (click)="onRowClick(row)"
      >
        <td
          *ngFor="let column of columns"
          [style.cursor]="
            column.field === 'workName' || column.field === 'companyName'
              ? 'pointer'
              : 'default'
          "
          (click)="
            column.field === 'workName'
              ? onWorkNameClick(row.workId)
              : column.field === 'companyName'
               ? onCompanyNameClick(row)
              : null
          "
        >
          <ng-container *ngIf="column.template; else defaultCell">
            <ng-container
              *ngTemplateOutlet="
                column.template;
                context: { $implicit: row[column.field], row: row }
              "
            ></ng-container>
          </ng-container>
          <ng-template #defaultCell>
            <span [title]="row[column.field]">{{
              row[column.field] | truncate : 28
            }}</span>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="pagination-container">
    <button
      class="pagination-button"
      (click)="mudarPagina(-1)"
      [disabled]="pagination.page === pagination.pageFirst"
      *ngIf="pagination.page > 1"
      type="button"
    >
      Anterior
    </button>

    <ng-container *ngFor="let page of visiblePages">
      <button
        class="pagination-number"
        [ngClass]="{ active: pagination.page === page }"
        (click)="paginaMudada.emit(page)"
        type="button"
      >
        {{ page }}
      </button>
    </ng-container>

    <button
      class="pagination-button"
      (click)="mudarPagina(1)"
      [disabled]="pagination.page === pagination.pageLast"
      type="button"
    >
      Próximo
    </button>
  </div>
</div>
